(() => {
  const root=document.querySelector('[data-kidz-product]');if(!root)return;
  const fine=matchMedia('(hover:hover) and (pointer:fine)');const en=root.dataset.lang==='en';
  root.querySelectorAll('.ic-flipcard').forEach(card=>{
    let active=false,hover=false;
    const draw=()=>{const back=active||hover;card.classList.toggle('is-flipped',back);card.setAttribute('aria-pressed',String(back));const hint=card.querySelector('.ic-flip__hint');if(hint)hint.textContent=en?(back?'Move away or tap to see the question':'Hover or tap to see the answer'):(back?'Éloigne la souris ou touche pour revoir la question':'Survole ou touche pour voir la réponse');};
    card.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&fine.matches){hover=true;active=false;draw();}});
    card.addEventListener('pointerleave',()=>{hover=false;draw();});
    card.addEventListener('click',e=>{if(e.detail&&hover&&fine.matches)return;active=!active;draw();});draw();
  });
  root.querySelectorAll('[data-kidz-buy]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();document.querySelector('product-info .product__info-container')?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}));
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)entry.target.classList.add('is-in');entry.target.classList.toggle('ntif-visible',entry.isIntersecting);}),{threshold:.05});root.querySelectorAll('.ic-board,.ic-feat').forEach(el=>observer.observe(el));}
  else root.querySelectorAll('.ic-board,.ic-feat').forEach(el=>el.classList.add('is-in','ntif-visible'));
})();
(() => {
  const root = document.querySelector('[data-kidz-product]');
  if (!root) return;
  const grid = root.querySelector('.ic-flip__grid');
  const cards = [...grid.querySelectorAll('.ic-flipcard')];
  const gauges = [...grid.querySelectorAll('.ic-baro')];
  const ns = 'http://www.w3.org/2000/svg';
  const lines = document.createElementNS(ns, 'svg');
  lines.classList.add('kidz-level-lines');
  lines.setAttribute('aria-hidden', 'true');
  grid.append(lines);
  let queued = false;
  function update() {
    queued = false;
    const mobile = matchMedia('(max-width:749px)').matches;
    const frame = grid.getBoundingClientRect();
    const boxes = cards.map(card => {
      const box = card.getBoundingClientRect();
      return { top: box.top, left: box.left, right: box.right, height: card.querySelector('.ic-flipcard__in').offsetHeight };
    });
    const levels = cards.map(card => JSON.parse(card.dataset.levelPositions)[card.classList.contains('is-flipped') ? 1 : 0]);
    const positions = boxes.map((box, index) => levels[index].map(p => box.top - frame.top + p * box.height));
    lines.setAttribute('viewBox', `0 0 ${frame.width} ${frame.height}`);
    lines.replaceChildren();
    function gauge(index, targets, height) {
      const g = gauges[index];
      g.style.height = `${height}px`;
      const offset = g.getBoundingClientRect().top - frame.top;
      const top = targets[0] - offset - 14;
      const scale = g.querySelector('.ic-baro__scale');
      scale.style.top = `${top}px`;
      scale.style.height = `${targets[4] - targets[0] + 28}px`;
      g.querySelectorAll('.ic-baro__tick').forEach((tick, i) => tick.style.top = `${targets[i] - offset - top}px`);
      const caps = g.querySelectorAll('.ic-baro__cap');
      caps[0].style.top = `${top - 42}px`;
      caps[1].style.top = `${targets[4] - offset + 25}px`;
      return g.getBoundingClientRect().left - frame.left + g.getBoundingClientRect().width / 2;
    }
    function line(x1, y1, x2, y2) {
      const p = document.createElementNS(ns, 'path');
      p.setAttribute('d', `M${x1} ${y1}L${x2} ${y2}`);
      lines.append(p);
    }
    if (mobile) {
      boxes.forEach((box, c) => {
        const x = gauge(c, positions[c], box.height);
        positions[c].forEach(y => line(box.right - frame.left + 3, y, x - 15, y));
      });
    } else {
      const middle = positions[0].map((y, i) => (y + positions[1][i]) / 2);
      const x = gauge(0, middle, boxes[0].height);
      middle.forEach((y, i) => {
        line(boxes[0].right - frame.left + 3, positions[0][i], x - 19, y);
        line(x + 19, y, boxes[1].left - frame.left - 3, positions[1][i]);
      });
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  new ResizeObserver(schedule).observe(grid);
  cards.forEach(card => {
    new MutationObserver(schedule).observe(card, { attributes: true, attributeFilter: ['class'] });
    card.querySelectorAll('img').forEach(image => image.addEventListener('load', schedule));
  });
  document.fonts.ready.then(schedule);
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
